@if(service.viewDroplistItems.length){
<div class='experience-ai-advisor-views-part'>

	@if(service.selectedViewItem(); as selectedViewItem){

	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem'
		(selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true'
		sortBy='customSort' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.PromptResponse) {
	<experience-ai-advisor-prompt-responses-view-part></experience-ai-advisor-prompt-responses-view-part>
	}
	@case (service.viewId.PromptError) {
	<experience-ai-advisor-prompt-errors-view-part></experience-ai-advisor-prompt-errors-view-part>
	}
	}
	}

</div>
}